import { motion } from "framer-motion";
import { Building2, MapPin, X } from "lucide-react";

const BranchDetailsModal = ({ branch, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-3xl p-6 max-w-lg w-full mx-4 relative"
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 p-2 rounded-xl hover:bg-gray-100 transition-colors"
        >
          <X className="w-4 h-4 text-gray-500" />
        </button>

        {/* Header */}
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-[#FF6C6C]/10 flex items-center justify-center">
            <Building2 className="w-6 h-6 text-[#FF6C6C]" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900">
              {branch.name}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <MapPin className="w-4 h-4 text-[#FF6C6C]" />
              <span className="text-[#FF6C6C] font-medium">
                {branch.region}
              </span>
            </div>
          </div>
        </div>

        {/* Details */}
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Location</p>
              <p className="text-gray-900">{branch.location}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm text-gray-500">Phone Number</p>
              <p className="text-gray-900">{branch.phoneNumber}</p>
            </div>
            {branch.district && (
              <div className="space-y-1">
                <p className="text-sm text-gray-500">District</p>
                <p className="text-gray-900">{branch.district}</p>
              </div>
            )}
            {branch.suburb && (
              <div className="space-y-1">
                <p className="text-sm text-gray-500">Suburb</p>
                <p className="text-gray-900">{branch.suburb}</p>
              </div>
            )}
            {branch.landmark && (
              <div className="space-y-1">
                <p className="text-sm text-gray-500">Landmark</p>
                <p className="text-gray-900">{branch.landmark}</p>
              </div>
            )}
            {branch.gpsAddress && (
              <div className="space-y-1">
                <p className="text-sm text-gray-500">GPS Address</p>
                <p className="text-gray-900">{branch.gpsAddress}</p>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    </div>
  );
};
export default BranchDetailsModal;